import React from 'react';

export interface TableHeaderProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  children: React.ReactNode;
  className?: string;
}

const TableHeader = React.forwardRef<HTMLTableSectionElement, TableHeaderProps>(({
  children,
  className = '',
  ...props
}, ref) => (
  <thead ref={ref} className={className} {...props}>
    {children}
  </thead>
));

TableHeader.displayName = 'TableHeader';

export default TableHeader;
